import { deliveryCountry } from "./visitor-country";

//The checkout's state dropdown, filled with the regions of the country the
//order ships to - historically a per-folder js/indianstates.js copy on the
//Indian funnels. The full region name is both the option value and label: it
//is what the CRM receives and what the PIN autofill matches against. Only
//completely empty selects are filled, so a page that ships its own list (or
//still loads its local script) always wins. Adding a market is a data-only
//change.
const STATES_BY_MARKET = {
	IN: [
		"Andaman and Nicobar Islands",
		"Andhra Pradesh",
		"Arunachal Pradesh",
		"Assam",
		"Bihar",
		"Chandigarh",
		"Chhattisgarh",
		"Dadra and Nagar Haveli",
		"Daman and Diu",
		"Delhi",
		"Goa",
		"Gujarat",
		"Haryana",
		"Himachal Pradesh",
		"Jammu and Kashmir",
		"Jharkhand",
		"Karnataka",
		"Kerala",
		"Ladakh",
		"Lakshadweep",
		"Madhya Pradesh",
		"Maharashtra",
		"Manipur",
		"Meghalaya",
		"Mizoram",
		"Nagaland",
		"Odisha",
		"Puducherry",
		"Punjab",
		"Rajasthan",
		"Sikkim",
		"Tamil Nadu",
		"Telangana",
		"Tripura",
		"Uttar Pradesh",
		"Uttarakhand",
		"West Bengal",
	],
};

//Marks the selects this feature filled, so a later country change can replace
//its own list without ever touching one the page brought itself.
const FILLED_FOR = "data-state-list";

export function stateList() {
	//Deliberately later than the rest of boot: a page-local states script
	//registers its DOMContentLoaded listener during parse, so waiting for
	//that event lets the local copy fill first and this feature bail out -
	//running at boot (which fires before the event) would fill underneath
	//it and double the list.
	if (document.readyState === "complete") {
		fillStates();
	} else {
		window.addEventListener("DOMContentLoaded", fillStates);
	}

	//A landing can offer more than one delivery country, so follow the field
	//rather than assume the market stays put.
	document.addEventListener("change", (event) => {
		if (event.target && event.target.name === "country") {
			fillStates();
		}
	});
}

function fillStates() {
	document.querySelectorAll('select[name="state"]').forEach((select) => {
		const country = deliveryCountry(select);
		const states = STATES_BY_MARKET[country];

		if (!states || select.getAttribute(FILLED_FOR) === country) {
			return;
		}
		//Anything already in the select belongs to the page, unless this
		//feature is the one that put it there for another country.
		if (select.options.length > 0 && !select.hasAttribute(FILLED_FOR)) {
			return;
		}

		select.innerHTML = "";

		const placeholder = document.createElement("option");
		placeholder.value = "";
		placeholder.textContent = "Select State";
		select.appendChild(placeholder);

		states.forEach((name) => {
			const option = document.createElement("option");
			option.value = name;
			option.textContent = name;
			select.appendChild(option);
		});

		select.setAttribute(FILLED_FOR, country);
	});
}
